<template>
  <action-button
    :type="type"
    :variant="variant"
    :enabled="delayedEnabled"
    :running="delayedRunning"
    :idleLabel="idleLabel"
    :runningLabel="runningLabel"
    @click="clickHandler"
  />
</template>

<script>
const DELAY_MSEC = 200;

import ActionButton from './ActionButton.vue';

export default {
  name: 'DelayedActionButton',

  components: {
    ActionButton,
  },

  props: {
    type: {
      type: String,
      default: 'button',
    },

    variant: {
      type: String,
      default: 'secondary',
    },

    enabled: {
      type: Boolean,
      default: true,
    },

    running: {
      type: Boolean,
      default: false,
    },

    idleLabel: {
      type: String,
      required: true,
    },

    runningLabel: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      delayedEnabled: this.enabled,
      enabledTimeoutId: null,

      delayedRunning: this.running,
      runningTimeoutId: null,
    };
  },

  watch: {
    enabled(newEnabledValue) {
      this.clearEnabledTimeout();

      if(newEnabledValue) {
        // Enabled started. Start delay.
        this.enabledTimeoutId = setTimeout(this.onEnabledTimeout, DELAY_MSEC);
      } else {
        // Enabled finished. React without delay.
        this.delayedEnabled = false;
      }
    },

    running(newRunningValue) {
      this.clearRunningTimeout();

      if(newRunningValue) {
        // Running started. Start delay.
        this.runningTimeoutId = setTimeout(this.onRunningTimeout, DELAY_MSEC);
      } else {
        // Running finished. React without delay.
        this.delayedRunning = false;
      }
    },
  },

  beforeDestroy() {
    this.clearEnabledTimeout();
    this.clearRunningTimeout();
  },

  methods: {
    onEnabledTimeout() {
      this.clearEnabledTimeout();
      this.delayedEnabled = true;
    },

    onRunningTimeout() {
      this.clearRunningTimeout();
      this.delayedRunning = true;
    },

    clearEnabledTimeout() {
      if(this.enabledTimeoutId !== null) {
        clearTimeout(this.enabledTimeoutId);
        this.enabledTimeoutId = null;
      }
    },

    clearRunningTimeout() {
      if(this.runningTimeoutId !== null) {
        clearTimeout(this.runningTimeoutId);
        this.runningTimeoutId = null;
      }
    },

    clickHandler(event) {
      this.$emit('click', event);
    },
  },
};
</script>
